
import Navbar from './Components/Navbar';
import Bannerbanner from "./Components/Banner";
import Explorepage from "./Components/Explorepage";
import Launchpage from "./Components/Launchpage";
import Cartpage from "./Components/Cartpage"
import Experiencepage from './Components/Experiencepage';
import Officalpage from './Components/Officalpage';
import Presspage from './Components/Presspage';
import Footer from './Components/Footer';

function App() {
  return (
    <>
    
    <Navbar />
    <Bannerbanner />
    <Explorepage />
    <Launchpage />
    <Cartpage />
    <Experiencepage />
    <Officalpage />
    <Presspage />
    <Footer />
    </>
  );
}

export default App;
